import type React from 'react'

import { cn } from '@/lib/utils'

import type { ImageProps } from './types'

export type { ImageProps } from './types'

/**
 * next/image, reduced to the two ways this app uses it (fill + object-contain,
 * with or without priority). `fill` reproduces the absolutely positioned full-size
 * box next/image emitted through classes, not an inline style object. `sizes` only
 * drives Next's srcset generation, which does not exist here, so it is dropped.
 */
export default function Image({
  src,
  alt,
  fill,
  priority,
  sizes: _sizes,
  width,
  height,
  className,
  style,
  ...rest
}: ImageProps): React.ReactElement {
  return (
    <img
      src={src}
      alt={alt}
      width={fill ? undefined : width}
      height={fill ? undefined : height}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : undefined}
      decoding="async"
      className={cn(fill && 'absolute inset-0 h-full w-full', className)}
      style={style}
      {...rest}
    />
  )
}
